import React from "react";
import "./Progress.css";

const Progress = ({style, className = ""}) => (
    <i style={style} className={`fa fa-refresh loading-icon flex-loading-icon ${className}`}/>
);

export default Progress;